import React, { useState } from "react";

import { templates } from "@reactivated";

import { RichText } from "../../../common/RichText";
import { getOptionValueHash } from "../../../utils/catalogue";
import { ShopTileType } from "../ShopCompareTypes";
import { ShopTile } from "../ShopTile";

import styles from "../ShopCompare/index.module.scss";

interface IShopCompareGridProps {
    value: templates.ShopCompareGridTemplate;
}

export const ShopCompareGrid = (props: IShopCompareGridProps) => {
    console.log("🚀 ~ ShopCompareGrid ~ props:", props);
    const [selectedSize, setSelectedSize] = useState<string>("Queen");
    const tileset = props.value.tileset;
    if (!tileset) {
        return null;
    }

    // Get all size_options arrays from each shop_tile, filtering out nulls/undefined
    const allSizeOptions =
        tileset.shop_tiles?.value
            .map((shopTileObject) => {
                const shopTile = shopTileObject.value
                    .shop_tile as ShopTileType["shop_tile"];
                return shopTile && Array.isArray(shopTile.size_options)
                    ? shopTile.size_options
                    : undefined;
            })
            .filter((arr) => Array.isArray(arr)) || [];

    // Find intersection of all size options arrays
    const availableSizes = allSizeOptions.reduce((acc, curr) => {
        if (acc.length === 0) return curr;
        return acc.filter((size) => curr.includes(size));
    }, allSizeOptions[0] || []);

    const selectID = "select-id";
    const onSubmit = () => {};
    const onSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedSize(e.target.value);
    };
    return (
        <section className={styles.shopCompareContainer}>
            <RichText
                className={styles.header}
                html={props.value.header_copy}
            />
            <form className={styles.sizeSelector} onSubmit={onSubmit}>
                <label htmlFor={selectID}>Price by {selectedSize}</label>
                <select
                    id={selectID}
                    className="al-compareresults-selectsize"
                    onChange={onSelectChange}
                    value={selectedSize}
                >
                    {availableSizes.map((option) => {
                        return (
                            <option
                                key={getOptionValueHash(option)}
                                value={option}
                            >
                                {option}
                            </option>
                        );
                    })}
                </select>
            </form>
            <div className={styles.shopTileContainer}>
                {tileset.shop_tiles?.value.map((tile, index) => {
                    return (
                        <div key={index}>
                            <ShopTile
                                value={tile.value}
                                tilesetId={tileset.id}
                            />
                        </div>
                    );
                })}
            </div>
            <div className={styles.footer}>
                <RichText html={props.value.footer_copy} />
            </div>
        </section>
    );
};
